export default __webpack_public_path__ + "static/media/jumbo-img-1.c55a9e67.jpg";